import { BaseObject } from "../../../core/business-objects/base-object/base-object.model";
import { BaseObjectApiFacade } from "../../../core/business-objects/base-object/base-object.api-facade";
import { VASRestService } from "../../../core/services/api/vas-rest";
import { VasAppFacade } from "../../services/vas-app-facade.service";

export abstract class VasBaseObjectApiFacade<T extends BaseObject> extends BaseObjectApiFacade<T> {

    constructor(protected appFacade: VasAppFacade, protected api: VASRestService, protected entityName: string) {
        super(appFacade, api, entityName);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/base-object/vas-base-object.api-facade.ts